"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ContinuationEvent = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=_ContinuationEvent.js.map